<vdw-header [title]="'DESIGN_LIBRARY.DETAILS.SAVE_AS_EP.SAVE_AS_EP' | bmsTranslate" [canShowClose]="true" (closeEvent)="onCloseDrawingDetails()" (backEvent)="onCloseSaveAsEp()"></vdw-header>
<form [formGroup]="form" fxLayout="row" fxFlex fxLayoutAlign="start start" class="container" fxLayoutGap="24px">
  <div class="image-preview" fxFlex="176px" fxLayout="column" fxLayoutGap="8px">
    <h4>{{ 'DESIGN_LIBRARY.DETAILS.PREVIEW' | bmsTranslate }}</h4>

    <div class="drawing-image">
      <app-drawing-library-image-preview
        draggable="false"
        [drawingImage]="drawingConfigurationForEpDrawing.image"
        [qualityId]="getQualityId()"
        [colorSetId]="getColorSetId()"
        [drawingDimensionsInPx]="drawingDimensionsInPx"
        [areImagesUploading]="false"
        [shouldDownloadImage]="true"
      >
      </app-drawing-library-image-preview>
    </div>
  </div>
  <div fxFlex="calc(100% - 200px)" fxLayout="column" fxLayoutGap="8px">
    <h4>{{ 'DESIGN_LIBRARY.DETAILS.PARAMETERS' | bmsTranslate }}</h4>
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100">
        <div class="flex-row gap-24">
          <mat-form-field class="full-width">
            <mat-label>{{ 'DESIGN_LIBRARY.DETAILS.DESIGN_NAME' | bmsTranslate }}</mat-label>
            <mat-hint class="hint-wrap" *ngIf="canShowNameSuggestion()">
              <vdw-ellipsis-label
                [text]="'GENERAL.SUGGESTED_ATTRIBUTE' | bmsTranslate: {attribute: 'DESIGN_LIBRARY.DETAILS.NAME' | bmsTranslate | lowercase, value: drawingName}"
                matTooltipPosition="below"
                class="overflow-hidden"
              ></vdw-ellipsis-label>
              <a class="url" (mousedown)="applyDesignNameForEP()">{{ 'GENERAL.ACTIONS.APPLY' | bmsTranslate }}</a>
            </mat-hint>
            <input matInput type="text" formControlName="name" />
            <mat-error *ngIf="canShowErrorForFormControl('required', 'name')">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
            <mat-error *ngIf="canShowErrorForFormControl('identifierTaken', 'name')">
              {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>
              {{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} }}
            </mat-label>
            <vdw-object-selection
              formControlName="quality"
              [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} | lowercase"
              [chipValueKey]="QUALITY_CHIP_VALUE_KEY"
              [baseRouterLink]="QUALITY_BASE_ROUTER_LINK"
              (selectClicked)="selectQuality()"
              (clearClicked)="handleMachineQualitySelection(null)"
            ></vdw-object-selection>
            <mat-error *vdwCanShowErrorForFormControl="'quality'; error: 'required'">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex-row gap-24" *ngIf="isQualitySelected()">
          <mat-form-field class="full-width">
            <mat-label>{{ 'TEXTILE_DATA.COLOR_SET.COLOR_SET' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              formControlName="colorSet"
              [objectName]="'TEXTILE_DATA.COLOR_SET.COLOR_SET' | bmsTranslate: {count: 1} | lowercase"
              [baseRouterLink]="COLOR_SET_BASE_ROUTER_LINK"
              [inProgress]="recoloringImage"
              (selectClicked)="selectColorSet()"
            ></vdw-object-selection>
            <mat-error *vdwCanShowErrorForFormControl="'colorSet'; error: 'required'">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field *appHasPermission="FINISHING_VIEW_PERMISSION" class="full-width">
            <mat-label>
              {{ 'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} }}<span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
            </mat-label>
            <vdw-object-selection
              formControlName="finishing"
              [objectName]="'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} | lowercase"
              [chipValueKey]="FINISHING_CHIP_VALUE_KEY"
              [baseRouterLink]="FINISHING_BASE_ROUTER_LINK"
              (selectClicked)="selectFinishing()"
            ></vdw-object-selection>
          </mat-form-field>
          <mat-form-field *appHasPermission="MACHINE_VIEW_PERMISSION" class="full-width">
            <mat-label
              >{{ 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | bmsTranslate }}<span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span></mat-label
            >
            <vdw-object-selection
              formControlName="machine"
              [objectName]="'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase"
              [baseRouterLink]="MACHINE_BASE_ROUTER_LINK"
              (selectClicked)="selectMachine()"
            ></vdw-object-selection>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
<mat-toolbar fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="16px">
  <button mat-stroked-button (click)="onCloseSaveAsEp()">
    {{ 'GENERAL.ACTIONS.CANCEL' | bmsTranslate }}
  </button>

  <vdw-progress-button [inProgress]="saving" [disabled]="!canSaveAsEp()" label="DESIGN_LIBRARY.DETAILS.SAVE_AS_EP.SAVE_AS_EP" (progressClick)="saveAsEp()"></vdw-progress-button>
</mat-toolbar>
